<div class="vtr-snapshot-header">
	<div class="row">
		<h2 id="snapshot-header-card-title" class="col title" role="heading" aria-live="polite"
			[ngClass]="isSnapshotInProgress() ? 'animated-dots': 'hide-dots'"
		>{{ ('snapshot.') + getHeaderText() | translate }}<span aria-hidden="true" *ngFor="let dot of threeDots">{{dot}}</span></h2>
	</div>

	<div class="row snapshot-information" *ngIf="getSnapshotStatus() === snapshotStatusEnum.notStarted">
		<p class="snapshot-information-text">
			<span id="snapshot-header-information" role="text">{{ 'snapshot.snapshotInformation' | translate }}</span>
		</p>
		<div class="question-mark-container">
			<vtr-ui-question-mark-button
				[componentId]="'snapshot-header-tooltip-information'"
				[ariaLabel]="'snapshot-header-information tooltip, which reads: ' + ('snapshot.informationTooltipDescription' | translate)"
				[tooltipId]="'snapshot-header-information-tooltip'"
				[tooltipText]="'snapshot.informationTooltipDescription' | translate"
			></vtr-ui-question-mark-button>
		</div>
	</div>

	<div class="row">
		<div class="col button-row">
			<vtr-material-button
				linkId="snapshot-header-update-btn"
				[label]= "'snapshot.snapshotUpdateButton' | translate | uppercase"
				[isDisabled]="isSnapshotInProgress()"
				(buttonClick)="onTakeSnapshot()"
				[tooltipText]="'snapshot.updateSnapshotTooltip' | translate"
				heightSize="lg">
			</vtr-material-button>
			<vtr-ui-hyperlink-button
				linkId="snapshot-header-replace-baseline-btn"
				linkRole="button"
				class="hyperlink-container"
				hyperlinkStyle="xs-white"
				[isDisabled]="isSnapshotInProgress()"
				[label]="'snapshot.replaceBaseline' | translate"
				[upperCaseLabel]="true"
				(hyperlinkClick)="onReplaceBaseline()"
				[tooltipText]="'snapshot.replaceBaselineTooltip' | translate">
			</vtr-ui-hyperlink-button>
		</div>
	</div>
</div>
